import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { FilterProps } from 'components/Dashboard/types';
import { useAppSelector } from 'store/hooks';
import { selectModelsApi } from 'store/exec/execSlice';

import { Button, Checkbox, Input, Form, Select, Space } from 'antd';
import React from 'react';

const NamedModelsFilter: React.FC<FilterProps> = ({ onApply }) => {
  const modelsApi = useAppSelector(selectModelsApi);
  const [ form ] = Form.useForm<FilterParams>();
  const {
    modelApiParam,
    imageTagParam,
    isSandboxParam,
    isCvParam,
    isEnabledParam,
    setFilters,
    clearFilters,
  } = usePaginationParams();

  const onReset = () => {
    form.setFieldValue('modelApi', []);
    form.setFieldValue('imageTag', undefined);
    form.setFieldValue('isSandbox', false);
    form.setFieldValue('isCv', false);
    form.setFieldValue('isEnabled', false);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="namedModelsFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{
        modelApi: modelApiParam !== '' ? modelApiParam.split(',') : [],
        imageTag: imageTagParam || undefined,
        isSandbox: isSandboxParam,
        isCv: isCvParam,
        isEnabled: isEnabledParam,
      }}
    >
      <Form.Item name="modelApi" label="Model API">
        <Select placeholder="Select model API" mode="multiple" options={modelsApi} allowClear />
      </Form.Item>

      <Form.Item name="imageTag" label="Image tag">
        <Input placeholder="Enter image tag" />
      </Form.Item>

      <Form.Item valuePropName="checked" name="isCv">
        <Checkbox>Clinical Validated</Checkbox>
      </Form.Item>

      <Form.Item valuePropName="checked" name="isSandbox">
        <Checkbox>Is sandbox</Checkbox>
      </Form.Item>

      <Form.Item valuePropName="checked" name="isEnabled">
        <Checkbox>Enabled</Checkbox>
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default NamedModelsFilter;
